import React from "react";

interface SnEmptyProps {
  inputRef?: any;
  onFocus?: (target: string) => void;
}

export function SnEmpty({ inputRef, onFocus }: SnEmptyProps) {
  const handleFocus = () => {
    onFocus && onFocus("next");
  };

  return (
    <div
      className="flex items-center w-full"
      ref={inputRef}
      onFocus={handleFocus}
      tabIndex={-1}
    ></div>
  );
}

export default React.memo(SnEmpty);
